var _g, _rect, _g2, _rect2, _rect3, _rect4, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLegendary(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 44,
    height: 61,
    viewBox: "0 0 44 61",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_ii_122_3513)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.670532,
    y: 0.504395,
    width: 42.8886,
    height: 59.5675,
    rx: 5.95675,
    fill: "#FFE009"
  }))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_122_3513)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 6.62732,
    y: 6.461,
    width: 30.9751,
    height: 46.4626,
    rx: 2.3827,
    fill: "#D0C054"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_122_3513)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.7633 36.6923H16.9358C16.4358 36.6923 16.1857 36.4423 16.1857 35.9422V19.7891C16.1857 19.289 16.4358 19.039 16.9358 19.039H19.8864C20.3865 19.039 20.6365 19.289 20.6365 19.7891V32.4415H29.7633C30.2634 32.4415 30.5134 32.6916 30.5134 33.1917V35.9422C30.5134 36.4423 30.2634 36.6923 29.7633 36.6923Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.2
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 11.731,
    height: 50.0434,
    transform: "matrix(0.629622 0.776902 -0.792172 0.610298 36.7394 4.13776)",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "luminosity"
    },
    opacity: 0.2
  }, _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 4.69241,
    height: 47.1996,
    transform: "matrix(0.629622 0.776902 -0.792172 0.610298 41.4834 18.88)",
    fill: "white"
  })))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 7.22299,
    y: 7.05667,
    width: 29.7837,
    height: 45.2713,
    rx: 1.78702,
    stroke: "#C28017",
    strokeWidth: 1.19135
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_ii_122_3513",
    x: 0.670532,
    y: -0.686955,
    width: 42.8885,
    height: 61.9502,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.3827,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect1_innerShadow_122_3513"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.19135
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 1 0 0 0 0 1 0 0 0 0.3 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "hard-light",
    in2: "shape",
    result: "effect1_innerShadow_122_3513"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feMorphology", {
    radius: 2.3827,
    operator: "erode",
    in: "SourceAlpha",
    result: "effect2_innerShadow_122_3513"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: -1.19135
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_122_3513",
    result: "effect2_innerShadow_122_3513"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_122_3513",
    x: 16.1857,
    y: 19.039,
    width: 14.3278,
    height: 18.6533,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.849935 0 0 0 0 0.52189 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_122_3513"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_122_3513"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 6.62732,
    y: 6.461,
    width: 30.9751,
    height: 46.4626,
    rx: 2.3827,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLegendary);
export default __webpack_public_path__ + "static/media/legendary.d6965931547f3fd97170f5f41784dbe9.svg";
export { ForwardRef as ReactComponent };